/* eslint-disable @typescript-eslint/no-explicit-any */

import { config } from "@/config";
import {
  IIServiceabilityResponse,
  IV1ServiceabilityAddressPostRequest,
  IV1ServiceabilityBuildingPostRequest,
  v1ServiceabilityAddressPost,
  v1ServiceabilityBuildingPost,
} from "@/contract/generated/electrify-v1";
import { useApi } from "@/hooks/useApi";
import { isError } from "@/utils";
import { getSessionId } from "@/utils/sessionId";

export const useServiceability = () => {
  const { call } = useApi();

  const makeRequest = async (apiCall: () => Promise<any>) => {
    const serviceability = await call(apiCall);

    if (isError(serviceability)) {
      return {
        error: serviceability as Error,
      };
    }

    const response = serviceability as IIServiceabilityResponse;

    if (response.sessionId) {
      return {
        error: undefined,
      };
    }

    return {
      error: new Error("sessionId is not available"),
    };
  };

  return {
    checkAddressAndSystem: async (addressDetails: any, systemType: string) => {
      const data: IV1ServiceabilityAddressPostRequest = {
        sessionId: getSessionId(),
        address: addressDetails,
        systemType,
      };

      return await makeRequest(() =>
        v1ServiceabilityAddressPost(config.apiBasePath, data)
      );
    },
    checkBuildingStructure: async (roofMaterial: string, storeys: number) => {
      const data: IV1ServiceabilityBuildingPostRequest = {
        sessionId: getSessionId(),
        roofMaterial,
        storeys,
      };

      return await makeRequest(() =>
        v1ServiceabilityBuildingPost(config.apiBasePath, data)
      );
    },
  };
};
